<template>
  <div class="" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.7)">
    <div class="homeContent">
      <div class="leftNav" ref="leftNav">
        <div class="CTClassification" ref="CTClassification">
          <div id="classifyScroll" :class="showLeftIcon ? 'active' : ''">
            <div class="classifys">
              <div class="rightIcon">
                <i name="arrow" class="el-icon-arrow-right " v-show="showRightIcon" @click="rightClick" />
              </div>
              <div class="leftIcon">
                <i class="el-icon-arrow-left " v-show="showLeftIcon" @click="leftClick" />
              </div>
              <div class="classifys-item" v-for="(item, index) in cantList" :key="index" :ref="`item${index}`"
                @click="currentCheck(item,index)">
                <div class="ctItem" :class="current == index ? 'currentCT' : ''">
                  {{ item.description }}
                </div>
              </div>

            </div>
          </div>

          <!-- <div class="ctItem" v-for="(v, i) in cantList" :key="i"  @click="currentCheck(v,i)">
            {{ v.description }}

          </div> -->
        </div>
        <div class="tableClassification">

          <div class="tableItem" v-for="(v, i) in tableList" :key="i" :class="bdStatus==i ? 'bd2' : ''"
            @click="openTai(v,i)"
            v-if="tableNumberList[tableDataStatus].type  == 'ALL' ||  v.statusCode == tableNumberList[tableDataStatus].type ">

            <div v-if="bdStatus==i " class="check" style="color:#fff">
              <i class="el-icon-check"></i>
            </div>

            <div class="surfer" v-if="bdStatus==i" @click.stop="correcting(v)">
              <el-tooltip class="item" effect="dark" content="此功能为修正餐桌状态，请谨慎使用" placement="top">

                <i class="el-icon-refresh"></i>
              </el-tooltip>
            </div>
            <div class="tableName">
              <div class="taiTitle">
                {{ v.code }}
              </div>
              <!-- <div>
              

              </div> -->
            </div>

            <!--  V,    "R",   "U",  "OO",  "D"，   L,   G,   C,    S,   O-->
            <!-- 空闲","预订","开台","维修","脏台", 点菜，送单，消单，挂账，结账 -->
            <div class="tableNum" :style="{
              background : 
              v.statusCode == 'D' ? '#5C656E' 
              : v.statusCode == 'R' ? '#5C97FB'
              : v.statusCode == 'G' ? '#2FC71D'
              : v.statusCode == 'V' ? '#E7E8F1'
              : v.statusCode == 'U' ? '#00CDC1' 
              : v.statusCode == 'OO' ? '#FF3C62' 
              : v.statusCode == 'L' ? '#AACC1E' 
              : '#A9C81C',color:v.statusCode == 'V' ? '#666' : '#fff'
              }
              ">
              <span>{{ v.people_number }} </span>
              <span v-if='v.scount' class="scountnumber" @click.stop="routerScount(v)">挂({{v.scount}})</span>
              <span>{{ v.statusCode == 'D' ? '脏台' : v.statusCode == 'G' ? '送单' :v.statusCode == 'V' ? '空闲' :v.statusCode == 'R' ? '预订' :v.statusCode == 'U' ? '开台' :v.statusCode == 'OO' ? '维修' :v.statusCode == 'L' ? '点菜' :'空闲' }}
              </span>
            </div>
          </div>
        </div>
        <div class="tableBottom">

          <div class="tableData" v-for="(v, i) in tableNumberList" :key="i" @click="tableDateNumber(v,i)"
            :class="tableDataStatus == i ? 'tablebg' :' '">
            <span>{{ v.num }} </span>
            <div :style="{ background: v.bgcolor, color: v.color }">
              {{ v.name }}
            </div>
          </div>

        </div>
      </div>
      <div class="view">
        <order :dcStatus="dcStatus" @Success="Success" />
      </div>
    </div>

    <el-dialog :title="`开台(${openTaiObj.code})`" :visible.sync="dialogVisible" width="460px" center
      :before-close="handleClose">
      <div>
        <div>
          <div class="titleTTT">类别</div>
          <div>
            <el-select v-model="region" placeholder="请选择活动区域">
              <el-option v-for="(v,i) in classBie" :key="i" :label="v.description" :value="v.code"></el-option>
            </el-select>
          </div>
        </div>
        <div>
          <div class="titleTTT">销售员</div>
          <div>

            <el-select v-model="salePersonObj.id" placeholder="请选择销售员">
              <el-option v-for="(v,i) in salePersonList" :key="i" :label="v.description" :value="v.id"></el-option>
            </el-select>

          </div>
        </div>
        <div>
          <div class="titleTTT">人数</div>
          <div>
            <el-input placeholder="请输入人数" v-model="PeopleNuminput" type='number' min='1' max="999">
            </el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="
            background: #0099ff;
            color: #fff;
            width: 120px;
            height: 60px;
            border-radius: 38px;
          " @click="dialogVisible = false">取 消</el-button>
        <el-button style="" type="primary" @click="openTAIClick" :loading='loading'>确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改桌子状态" :visible.sync="modifyTable" width="460px" center>
      <div class="addFoodMain">是否将餐桌改为空闲？</div>
      <span slot="footer" style="width: 100%; display: flex; justify-content: center" class="dialog-footer">
        <div>
          <el-button style="
              background: #0099ff;
              color: #fff;
              width: 120px;
              height: 60px;
              border-radius: 38px;
            " @click="modifyTable = false">取 消</el-button>
          <el-button style="" type="primary" @click="modifyV">确 定</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import order from "./components/rightOrder.vue";

  export default {
    components: {
      order,

    },
    data() {
      return {
        loading: false,
        nowID: '',
        nowstatus: '',
        modifyTable: false,
        classBie: [],
        salePersonList: [],
        dictTypeCode: 'PosMenuType',
        value: '1',
        tableDataStatus: 0,
        fullscreenLoading: true,
        outletsId: '',
        region: '',
        Job: '',
        openTaiObj: {},
        bdStatus: null,
        dcStatus: '0',
        salePersonObj: {
          id: ''
        },
        PeopleNuminput: "",
        dialogVisible: false,
        current: 0,
        cantList: [{
            description: "所有"
          },

        ],
        //       V,    "R",   "U",  "OO",  "D"，   L,   G,   C,    S,   O
        // <!-- 空闲","预订","开台","维修","脏台", 点菜，送单，消单，挂账，结账 -->
        tableNumberList: [{
            num: "0",
            name: "所有",
            bgcolor: "#fff",
            color: "#666",
            type: 'ALL'
          },
          {
            num: "0",
            name: "空闲",
            bgcolor: "#E7E8F1",
            color: "#666",
            type: 'V'
          },
          {
            num: "0",
            name: "预订",
            bgcolor: "#5E93FB",
            color: "#fff",
            type: 'R'
          },
          {
            num: "0",
            name: "开台",
            bgcolor: "#00CDC1",
            color: "#fff",
            type: 'U'
          },
          {
            num: "0",
            name: "点菜",
            bgcolor: "#AACC1E",
            color: "#fff",
            type: 'L'
          },
          {
            num: "0",
            name: "送单",
            bgcolor: "#3BCC1E",
            color: "#fff",
            type: 'G'
          },
          {
            num: "0",
            name: "上菜",
            bgcolor: "#FE9D24",
            color: "#fff",
            type: 'OO'
          },
          {
            num: "0",
            name: "脏台",
            bgcolor: "#5C656E",
            color: "#fff",
            type: 'D'
          },
          // { num: "0", name: "挂单", bgcolor: "#C293FE", color: "#fff" },
          // { num: "0", name: "维修", bgcolor: "#FF3C62", color: "#fff" },
        ],
        tableList: [],
        currentID: '',
        showRightIcon: true, // 是否显示右箭头
        maxClickNum: 0, // 最大点击次数
        lastLeft: 0, // 上次滑动距离
        clickNum: 0, // 点击次数
        statusCode: ""
      };
    },
    created() {

      this.getOutletsIdList()
      this.getdata()
      this.getList('', '', localStorage.getItem('posCode'))
    },
    computed: {
      showLeftIcon() {
        return this.clickNum > 0
      }
    },
    watch: {
      $route(to, from) {
        console.log('route', to, from);
        if (this.$route.query.success == 1) {
          console.log('route', this.$route.query.success);
          this.Success()
        }

      }
    },
    mounted() {
      this.$bus.$on('surfendTai', v => {
        this.surfendTai()
      })
      this.$bus.$on('statusCode', v => {
        this.statusCode = 'U'
      })
    },
    methods: {
      //换台后刷新
      surfendTai() {
        this.getList('', '', localStorage.getItem('posCode'));
        let orderID = JSON.parse(localStorage.getItem('openTaiUstatus'))
        if (orderID) {
          // console.log(orderID);
          this.sufendtableLists(orderID)
        }


      },

      sufendtableLists(v) {
        if (this.tableList.length) {
          // console.log(v);
          if (v) {
            this.tableList.map((e, i) => {
              if (e.id == v.id) {
                this.bdStatus = i
                this.dcStatus = v.statusCode
                let url = this.api.orderByTable + '?tableId=' + e.id + '&status=' + v.statusCode
                let methods = 'get'
                this.$axios({
                  url,
                  methods
                }).then(res => {
                  url = this.api.dishesCount + '?tableId=' + v.id + '&status=' + v.statusCode
                  this.$axios({
                    url,
                    methods
                  }).then(ress => {
                    console.log('dishesCount', ress);
                    this.$bus.emit('dishesCount', ress.data.data)
                  })
                  console.log(res.data.data);
                  this.$bus.emit('orderMenu', res.data.data)
                  this.$bus.emit('nowID', e.id)
                  this.$bus.emit('nowstatus', e.statusCode)
                  this.$bus.emit('routeStatus', 0)

                })
              }
            })
          } else {

            this.$bus.emit('orderMenu', '')
            this.$bus.emit('routeStatus', 1)
            this.$bus.emit('nowID', '')
            this.$bus.emit('nowstatus', '')

          }
        } else {
          setTimeout(() => {
            this.sufendtableLists(v)

          }, 500);
        }

      },
      Success() {
        this.current = 0
        this.getList('', '', localStorage.getItem('posCode'));
        let orderID = JSON.parse(localStorage.getItem('openTaiUstatus'))
        this.sufendtableList(orderID)


      },
      getdata() {
        let orderID = JSON.parse(localStorage.getItem('openTaiUstatus'))
        if (orderID) {
          this.sufendtableList(orderID)

        }
      },

      sufendtableList(v) {
        if (this.tableList.length) {
          this.tableList.map((e, i) => {
            if (e.id == v.id) {
              console.log(e.statusCode);
              if (this.statusCode) {
                v.statusCode = this.statusCode
              } else {
                v.statusCode = e.statusCode

              }
              this.bdStatus = i
              this.openTai(v, i)
              this.statusCode = ''
            }
          })


        } else {
          setTimeout(() => {
            this.sufendtableList(v)

          }, 500);
        }

      },
      getsalesPersonList() {
        let methods = 'get'
        let url = this.api.listByParam
        this.$axios({
          methods,
          url
        }).then(res => {
          console.log(res);
          this.salePersonList = res.data.data
          // this.salePersonObj.id = res.data.data[0].id
        })
      },
      getDictDataList(dictTypeCode) {

        let methods = 'get'
        let url = this.api.getDictDataList + '?dictTypeCode=' + dictTypeCode
        this.$axios({
          methods,
          url
        }).then(res => {
          console.log(res);
          this.classBie = res.data.data
          this.region = res.data.data[0].code

        })

      },
      //获取餐厅类型
      getOutletsIdList() {
        let methods = 'get'
        let url = this.api.getoutlets + '?posCode=' + localStorage.getItem('posCode')
        this.$axios({
          methods,
          url
        }).then(res => {
          console.log(res);
          this.cantList = [{
            description: "所有"
          }, ]
          res.data.data.forEach(v => {
            this.cantList.push(v)
          });

        })
        this.$nextTick(() => {
          this.getDomStyle()

        })
      },
      getList(outletsId, queryLike, posCode) {
        this.fullscreenLoading = true
        let methods = 'get'
        // let url = this.api.getTableList + '?outletsId='+outletsId+'&queryLike=' + queryLike + '&posCode=' + posCode
        let url =
          `${this.api.getTableList}?${outletsId ? 'outletsId=' : ''}${outletsId}&${queryLike ? 'queryLike=' : ''}${queryLike}&posCode=${posCode}`
        this.$axios({
          methods,
          url
        }).then(res => {
          // 去重
          let obj = {};
          this.tableList = res.data.data.reduce((cur, next) => {
            obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
            return cur;
          }, [])
          console.log(this.tableList);
          this.fullscreenLoading = false;
          let v = 0;
          let r = 0;
          let u = 0;
          let l = 0;
          let g = 0;
          let p = 0;
          let d = 0;
          this.tableList.forEach(value => {

            if (value.statusCode == 'V') {
              v++
            } else if (value.statusCode == 'D') {
              d++
            } else if (value.statusCode == 'G') {
              g++
            } else if (value.statusCode == 'R') {
              r++
            } else if (value.statusCode == 'U') {
              u++
            } else if (value.statusCode == 'L') {
              l++
            } else if (value.statusCode == 'R') {
              r++
            } else if (value.statusCode == 'P') {
              p++
            }
          })
          //       V,    "R",   "U",  "OO",  "D"，   L,   G,   C,    S,   O
          // <!-- 空闲","预订","开台","维修","脏台", 点菜，送单，消单，挂账，结账 -->
          this.tableNumberList[0].num = this.tableList.length
          this.tableNumberList[1].num = v
          this.tableNumberList[2].num = r
          this.tableNumberList[3].num = u
          this.tableNumberList[4].num = l
          this.tableNumberList[5].num = g
          this.tableNumberList[6].num = p
          this.tableNumberList[7].num = d

          console.log(v);

        })

      },
      tableDateNumber(v, i) {
        console.log(v, i);
        console.log(this.tableNumberList);
        this.tableDataStatus = i

      },
      //开台按钮
      openTAIClick() {

        if (!this.PeopleNuminput) {
          this.$notify.error({
            title: '输入的开台人数错误'
          });
          return
        }
        if (!this.salePersonObj.id) {
          this.$notify.error({
            title: '请先选择销售员'
          });
          return
        } else {
          let name = ''
          this.classBie.map(e => {
            if (e.code == this.region) {
              name = e.description
            }
          })
          let methods = 'post'
          let url = this.api.openTai
          let shift = localStorage.getItem('shift')
          let hotelCode = localStorage.getItem('hotelCode')

          let data = {
            shiftCode: shift,
            menuTypeCode: this.region,
            // menuTypeName: this.openTaiObj.description,
            menuTypeName: name,
            mealTableId: this.openTaiObj.id,
            mealTableNum: this.openTaiObj.code,
            // mealTableName: this.openTaiObj.outletsName,
            mealTableName: this.openTaiObj.description,
            peopleCount: this.PeopleNuminput,
            restaurant: this.openTaiObj.restaurant,
            salesPerson: this.salePersonObj,

          }
          this.loading = true
          this.$axios({
            methods,
            url,
            data
          }).then(res => {
            this.loading = false
            if (res.data.status == 0) {
              let {
                href
              } = this.$router.resolve({
                path: "/order",
                query: {
                  outletsId: this.openTaiObj.outletsId,
                  id: res.data.data.id
                }
              });
              window.open(href, "_parent");
              localStorage.setItem('openTaiUser', JSON.stringify(res.data.data))
              localStorage.setItem('openTaiUstatus', JSON.stringify(this.openTaiObj))

            } else {
              this.$notify.error({
                title: res.data.message
              });
            }
          })

        }

      },
      //修改桌子状态
      modifyV() {
        let url = this.api.updateV + '?id=' + this.currentID
        let methods = 'get'
        /*  let data = {
           id: this.currentID
         } */
        this.$axios({
          url,
          methods
        }).then(res => {
          console.log(res);
          if (res.data.status == 0) {
            this.$message({
              message: "修改成功",
              type: 'success'
            });
            this.modifyTable = false
            localStorage.removeItem('openTaiUstatus')
            if (this.current) {
              let id = this.cantList[this.current].id
              this.getList(id, '', localStorage.getItem('posCode'))

            } else {

              this.getList('', '', localStorage.getItem('posCode'))
            }

          }
        })
      },
      //点击餐桌
      openTai(v, i) {
        console.log('openTai', v);
        this.currentID = v.id
        if (v.statusCode == 'D') {
          // v.statusCode = 'V'
          this.modifyTable = true

        } else if (v.statusCode == 'V') {
          // 获取下拉框数据
          this.getDictDataList(this.dictTypeCode)
          this.getsalesPersonList()
          this.dialogVisible = true;
          this.openTaiObj = v
          this.bdStatus = i
          this.dcStatus = v.statusCode

        } else {
          this.bdStatus = i
          this.dcStatus = v.statusCode
          let url = this.api.orderByTable + '?tableId=' + v.id + '&status=' + v.statusCode
          let methods = 'get'

          this.$axios({
            url,
            methods
          }).then(res => {

            url = this.api.dishesCount + '?tableId=' + v.id + '&status=' + v.statusCode
            //获取未送单的数量
            this.$axios({
              url,
              methods
            }).then(ress => {
              // console.log('dishesCount', ress);
              this.$bus.emit('dishesCount', ress.data.data)
            })

            localStorage.setItem('openTaiUser', JSON.stringify(res.data.data))
            localStorage.setItem('openTaiUstatus', JSON.stringify(v))

            this.$bus.emit('orderMenu', res.data.data)
            this.$bus.emit('openTaiUstatus', v)
            this.$bus.emit('nowID', v.id)
            this.$bus.emit('nowstatus', v.statusCode)
            this.$bus.emit('routeStatus', 0)

          })
        }

      },
      currentCheck(v, i) {
        this.getList(v.id, '', localStorage.getItem('posCode'))
        console.log(v, i);
        this.current = i;
      },
      handleClose(done) {
        this.$confirm("确认关闭？")
          .then((_) => {
            done();
          })
          .catch((_) => {});
      },
      //餐桌修正
      correcting(v) {
        this.$confirm('此操作为修正餐桌状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let url = this.api.correcting + '?id=' + v.id
          let methods = 'get'
          this.$axios({
            url,
            methods
          }).then(res => {
            if (res.data.status == 0) {
              this.$message({
                type: 'success',
                message: '修正成功!'
              });
              this.Success()
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }

          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      //跳转至餐单查询界面，并找出这个餐桌的所有挂单项目
      routerScount(v) {

        localStorage.setItem('MenuQuery', JSON.stringify(v))
        this.$bus.$emit('MenuQuery', v)
      },
      //餐桌左右按钮
      getDomStyle() {
        let width = document.querySelectorAll('.classifys-item')[this.clickNum].offsetWidth
        // 获取最后一个元素距离左侧的距离
        let lastItemOffsetLeft = document.getElementsByClassName('classifys-item')[this.cantList.length - 1].offsetLeft
        // 获取可视区域宽度
        const lookWidth = document.getElementById('classifyScroll').clientWidth
        // 如果最后一个元素距离左侧的距离大于可视区域的宽度，表示最后一个元素没有出现，执行滚动效果
        //  this.showRightIcon = lastItemOffsetLeft > lookWidth + width
      },
      rightClick() {
        // 如果点击次数小于数组长度-1时，执行左滑动效果。
        if (this.clickNum < this.cantList.length - 1) {
          // 获取当前元素宽度
          let width = document.querySelectorAll('.classifys-item')[this.clickNum].offsetWidth
          // 获取最后一个元素距离左侧的距离
          let lastItemOffsetLeft = document.getElementsByClassName('classifys-item')[this.cantList.length - 1]
            .offsetLeft
          // 获取可视区域宽度
          const lookWidth = document.getElementById('classifyScroll').clientWidth
          // 如果最后一个元素距离左侧的距离大于可视区域的宽度，表示最后一个元素没有出现，执行滚动效果
          console.log('获取当前元素的宽度', width, lastItemOffsetLeft, lookWidth);

          if (lastItemOffsetLeft > lookWidth) {

            // // 第一次点击的时候，加上左右箭头的距离
            if (this.clickNum == 0) {
              // 公示：滚动距离（元素的magin-left值） = 负的它自己的长度 + 上一次滑动的距离
              document.getElementsByClassName('classifys')[0].style.marginLeft = `${-width + this.lastLeft -20}px`
            } else {
              document.getElementsByClassName('classifys')[0].style.marginLeft = `${-width + this.lastLeft -20}px`
            }
            this.lastLeft = -width + this.lastLeft
            console.log(this.lastLeft);
            // 点击次数+1
            this.clickNum += 1
            // 记录到最后一个元素出现在可视区域时，点击次数的最大值。用于后面点击左侧箭头时判断右侧箭头的显示
            this.maxClickNum = this.clickNum
          }
          /* 
            如果最后一个元素距离左侧的距离大于可视距离+自身的宽度，说明没有到最后一个, 显示右侧箭头，否则隐藏右侧箭头
            注意：这里要加上其自身的宽度，否则要多点击一下才会隐藏。因为点击的时候实际上最后一个元素还没有滚动，
            它距离左侧的距离是大于可视区域的（也就是说获取的是上一次点击之后，距离左侧的距离）
            所以这里要加上其自身的宽度
            看不懂的话不用管，反正加上就对了
          */
          this.showRightIcon = lastItemOffsetLeft > lookWidth
        }
      },
      // 点击左箭头（右侧滚动）
      leftClick() {
        // console.log(this.lastLeft, 'lastLeft')
        // console.log(document.querySelectorAll('.classifys-item')[this.clickNum - 1].offsetWidth, '上一个的宽度')
        // 当点击次数大于0时才触发，这样当点击次数clickNum等于1的到时候，clickNum--等于0.根据计算属性的判断会隐藏掉左箭头
        if (this.clickNum > 0) {
          // 获取当前元素宽度
          let width = document.querySelectorAll('.classifys-item')[this.clickNum - 1].offsetWidth
          // 公示：滚动距离（元素的magin-left值） = 它自己的长度 + 上一次滑动的距离
          document.getElementsByClassName('classifys')[0].style.marginLeft = `${this.lastLeft + width}px`
          this.lastLeft = width + this.lastLeft
          // 点击次数-1
          this.clickNum--
          // 如果点击次数小于最大点击次数，说明最后一个元素已经不在可是区域内了，显示右箭头
          if (this.clickNum < this.maxClickNum) {
            this.showRightIcon = true
          }
        }
      }


    },

  };
</script>

<style lang="scss" scoped>
  @function px($px) {
    @return $px * 2px;
  }

  .bd2 {
    border: 2px solid #ff4757 !important;
    width: 100%;
    height: 100%;
    background: #edf8ff;
    position: relative;
  }

  .check {
    position: absolute;
    top: -1px;
    left: -1px;
    background: #ff4757;
    border-radius: 0 0 40% 0;
  }

  .surfer {
    position: absolute;
    top: 0px;
    right: 3px;
    display: flex;
    justify-content: end;
    margin-top: 5px;
    margin-right: 10px;
    font-size: 20px;
  }

  .main {
    display: flex;
    position: relative;
  }

  .homeContent {
    width: 100%;
    padding: 10px;

    .leftNav {
      width: 46%;
      // min-height: calc(100vh - 149px);

      // height: 100%;
      height: calc(100vh - 80px);
      // margin-right: 10px;
      // border-radius: 20px;
      position: absolute;
      top: 0px;
      left: 0px;
      background: #fff;
      border-right: 1px solid #eaeaea;
      overflow-x: auto;

      // .CTClassification {
      //   display: flex;
      //   margin: 0px 0px;
      //   border-bottom: 1px solid #eaeaea;
      //   padding: 13px;
      //   overflow-x: auto;
      //   .ctItem {
      //     width: 130px;
      //     height: 40px;
      //     text-align: center;
      //     line-height: 40px;
      //     border-radius: 20px;
      //     color: #666666;
      //     cursor: pointer;
      //   }
      //   .currentCT {
      //     background: #0099ff;
      //     color: #fff;
      //   }
      // }
      .CTClassification {
        position: relative;
        border-bottom: 1px solid #eaeaea;
        height: 66px;
      }

      .tableClassification {
        padding: 0 10px;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow-y: auto;
        height: calc(100vh - 230px);

        .tableItem {
          cursor: pointer;
          width: 18%;
          height: 124px;
          border: 1px solid #716f6f;
          border-radius: 6px;
          display: flex;
          flex-direction: column;
          color: #666;
          margin: 5px;
          position: relative;

          .tableName {
            line-height: 40px;
            font-weight: 500;
            font-size: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 8px;
            margin-top: 20px;
          }
          .taiTitle {
            display: block;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow:ellipsis;
            text-align: center
          }

          .taiTitle:hover {
            display: block;
            overflow: visible
          }
         

          .tableNames {
            line-height: 40px;
            font-weight: 500;
            font-size: 18px;
            display: flex;
            justify-content: center;
            margin-bottom: 8px;
          }

          .tableNum {
            width: 100%;
            align-items: flex-end;
            display: flex;
            justify-content: space-between;
            border-radius: 0 0 6px 6px;
            line-height: 44px;
            margin-top: 9px;
            padding: 0 20px;
          }

          .scountnumber {
            // position: absolute;
            // top: 16px;
            // left: 16px;
            // background: #fe9d24;
            // // border-radius: 80%;
            // width: 30px;
            // height: 30px;
            text-align: center;
            display: block;

            // line-height: 30px;
          }
        }
      }

      .tableBottom {
        height: 80px;
        display: flex;
        justify-content: space-around;
        // margin-top: 4px;
        padding-top: 10px;
        border-top: 1px solid #eaeaea;

        .tableData {
          width: 80px;
          display: flex;
          flex-direction: column;
          align-items: center;

          span {
            margin-bottom: 5px;
            font-size: 18px;
          }

          div {
            width: 52px;
            font-size: 16px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            border-radius: 6px;
          }
        }
      }
    }

    .view {
      width: 54%;
      height: calc(100vh - 80px);
      // height: 100%;
      // height: 1;
      // border-radius: 20px;
      position: absolute;
      top: 0px;
      right: 0px;
      background: #fff;
      display: flex;
      flex-direction: column;
    }
  }

  .tablebg {
    border: 2px solid #70a1ff !important;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    background: #edf8ff;
    position: relative;
  }

  #classifyScroll {
    padding: px(8) px(6) px(4);
    width: 95%;
    overflow: hidden;
    transition: all 0.3s;

    // 鼠标点击后，页面可视宽度变低
    &.active {
      transition: all 0.3s;
      width: 84%;
      margin: 0 auto;
    }

    .classifys {
      transition: all 0.3s;
      display: flex;
      align-items: center;

      .rightIcon {
        position: absolute;
        right: px(2);
        bottom: 47%;
        transform: translate(0, 50%);
        z-index: 9;
      }

      .leftIcon {
        position: absolute;
        left: px(5);
        bottom: 47%;
        transform: translate(0, 50%);
        z-index: 9;
      }

      &-item {
        font-size: px(11);
        font-weight: 400;
        color: #666;
        width: 130px;
        line-height: px(16);
        // margin-right: px(52);
        // padding: 0 px(4);
        white-space: nowrap;
        border-radius: 20px;
        cursor: pointer;
      }

      .ctItem {
        width: 130px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-radius: 20px;
        color: #666666;
        cursor: pointer;
      }

      .currentCT {
        background: #0099ff;
        color: #fff;
      }
    }
  }
</style>
<style lang="scss" scoped>
  /deep/.el-button--primary {
    border-radius: 38px;
    width: 180px;
    background: -webkit-gradient(linear,
        0 0,
        0 100%,
        from(#ffbe34),
        to(#fe812f)) !important;
    border: none;
  }

  /deep/.el-button {
    font-size: 18px;
    height: 60px;
    font-weight: 400;
  }

  /deep/.el-dialog__footer {
    margin-bottom: 30px;
  }

  /deep/.el-dialog {
    // height: 612px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
  }

  /deep/.el-dialog__header {
    margin-top: 50px;
    background: #fff;
  }

  /deep/.el-dialog__title {
    color: #0099ff;
    font-size: 18px;
  }

  /deep/.el-input__inner {
    width: 340px;
    height: 66px;
    line-height: 66px;
  }

  /deep/.el-input--suffix {
    margin-bottom: 20px;
  }

  /deep/.el-dialog__body {
    // height: 412px;
    overflow: hidden;
  }

  .titleTTT {
    margin-bottom: 10px;
    color: #666;
  }
</style>